var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Vk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,4h-18c-1.105,0 -2,0.895 -2,2v18c0,1.105 0.895,2 2,2h18c1.105,0 2,-0.895 2,-2v-18c0,-1.105 -0.895,-2 -2,-2zM21.361,18.967l-1.868,0.026c0,0 -0.403,0.079 -0.93,-0.285c-0.699,-0.48 -1.358,-1.729 -1.872,-1.567c-0.521,0.166 -0.505,1.29 -0.505,1.29c0,0 0.004,0.198 -0.115,0.327c-0.129,0.139 -0.382,0.125 -0.382,0.125h-0.837c0,0 -1.846,0.153 -3.473,-1.543c-1.772,-1.849 -3.338,-5.498 -3.338,-5.498c0,0 -0.092,-0.23 0.006,-0.348c0.111,-0.13 0.41,-0.134 0.41,-0.134l2,-0.01c0,0 0.188,0.033 0.324,0.133c0.111,0.082 0.174,0.236 0.174,0.236c0,0 0.323,0.819 0.752,1.561c0.836,1.446 1.224,1.763 1.508,1.608c0.414,-0.226 0.29,-2.044 0.29,-2.044c0,0 0.008,-0.66 -0.208,-0.954c-0.168,-0.229 -0.484,-0.297 -0.622,-0.314c-0.113,-0.015 0.071,-0.277 0.311,-0.395c0.36,-0.176 0.996,-0.186 1.747,-0.179c0.585,0.006 0.754,0.042 0.982,0.098c0.69,0.167 0.456,0.811 0.456,2.356c0,0.495 -0.089,1.191 0.267,1.42c0.154,0.099 0.529,0.015 1.464,-1.579c0.445,-0.756 0.778,-1.644 0.778,-1.644c0,0 0.073,-0.158 0.186,-0.226c0.116,-0.07 0.272,-0.048 0.272,-0.048l2.105,-0.013c0,0 0.632,-0.076 0.735,0.211c0.108,0.3 -0.236,1.001 -1.096,2.148c-1.412,1.884 -1.569,1.709 -0.396,2.799c1.12,1.041 1.351,1.547 1.39,1.611c0.463,0.771 -0.515,0.832 -0.515,0.832z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Vk);
export default __webpack_public_path__ + "static/media/icons8-vk.a050fc5e0493d4c5a5a939feab267c9c.svg";
export { ForwardRef as ReactComponent };